export const TEST_ID = 'multiSelectBatteryField';
